"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const design_system_1 = require("@zapier/design-system");
const core_1 = require("@emotion/core");
const utils_1 = require("./utils");
const smallIcon = {
    fontSize: '8px',
    borderRadius: '4px',
    height: '14px',
    width: '14px',
};
const mediumIcon = {
    fontSize: '12px',
    borderRadius: '4px',
    height: '18px',
    width: '18px',
};
const mediumLargeIcon = {
    fontSize: '12px',
    borderRadius: '5px',
    height: '20px',
    width: '20px',
};
const largeIcon = {
    fontSize: '14px',
    borderRadius: '6px',
    height: '24px',
    width: '24px',
};
const xLargeIcon = {
    fontSize: '18px',
    borderRadius: '10px',
    height: '35px',
    width: '35px',
};
const megaIcon = {
    fontSize: '18px',
    borderRadius: '10px',
    height: '40px',
    width: '40px',
};
const PathIcon = ({ emoji, size, className, color }) => {
    const backgroundColor = utils_1.getPathColorStyle(color);
    const iconStyle = Object.assign({ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, backgroundColor, color: design_system_1.Colors.white }, {
        small: smallIcon,
        medium: mediumIcon,
        'medium-large': mediumLargeIcon,
        large: largeIcon,
        'x-large': xLargeIcon,
        mega: megaIcon,
    }[size]);
    return (core_1.jsx("div", { className: className, css: iconStyle }, emoji));
};
exports.default = PathIcon;
